import React from 'react';
import { Box, IconButton } from '../../ui/core';
import { ArrowForwardIcon } from '../../ui/icons';
import { hairline } from '../../ui/styles';

// The "open search" bar shared by the section rails (Driver Approvals, Users):
// a back arrow to dismiss plus a full-width search field, sitting across the top
// of the content card the way Intercom's search-open state does. The actual
// search widget (drivers vs. users) is passed in as children.
const SearchBar = ({ onClose, children }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      px: { xs: '16px', md: '24px' },
      py: '12px',
      borderBottom: (theme) => `1px solid ${hairline(theme)}`,
      flexShrink: 0,
    }}
  >
    <IconButton size="small" onClick={onClose} aria-label="Close search">
      <ArrowForwardIcon sx={{ fontSize: 20, transform: 'rotate(180deg)' }} />
    </IconButton>
    <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
  </Box>
);

export default SearchBar;
